import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases, type Purchase } from '../data/purchases';
import { PRODUCT_NAME } from './constants';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<Purchase>(purchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[250px] animate-slide-in" aria-live="polite" data-id="element-113" data-mp="165hcgvwws971">
      <div className="relative overflow-hidden rounded-xl border-2 border-eq-gold bg-white p-2 pr-6 shadow-2xl ring-2 ring-eq-navy/80" data-id="element-114" data-mp="116mges9xko4z">
        <div className="absolute inset-x-0 top-0 h-1 bg-eq-gold" data-id="element-115" data-mp="1awpm9t25hwkq" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1 top-1 rounded p-0.5 text-eq-muted transition-colors duration-150 ease-out hover:text-eq-navy" aria-label="Close notification" data-id="element-116" data-mp="1axhdkropt857">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-117" data-mp="x6c99caejroj" />
        </button>
        <div className="flex items-center gap-2" data-id="element-118" data-mp="s5olczhgzqyj">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-eq-gold bg-eq-gold/20" data-id="element-119" data-mp="s4wq5prsbv8s">
            <ShoppingBagIcon className="h-3.5 w-3.5 text-eq-navy" aria-hidden="true" data-id="element-120" data-mp="23ld9hu6gmw0x" />
          </span>
          <div className="min-w-0 leading-tight" data-id="element-121" data-mp="2aotjuc285thm">
            <p className="font-display text-[12px] font-extrabold text-eq-navy" data-id="element-122" data-mp="2ao1n2xww5ppr">{current.name}</p>
            <p className="text-[10px] font-semibold text-eq-muted" data-id="element-123" data-mp="2fm34zfikzizn">
              from {current.city}, {current.region}
            </p>
            <p className="mt-0.5 text-[10px] font-extrabold text-eq-gold" data-id="element-124" data-mp="2kkwhb4m4t3y8">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}